import client from '../client';
import uploadVideoToS3 from '../common/utils/uploadVideoToS3';

export const ADD_RESPONSE_VIDEO_TO_SUBMITTAL = 'ADD_RESPONSE_VIDEO_TO_SUBMITTAL';
export const FETCH_SUBMITTALS_HISTORY = 'FETCH_SUBMITTALS_HISTORY';
export const FETCH_SUBMITTALS_PENDING_REVIEW = 'FETCH_SUBMITTALS_PENDING_REVIEW';
export const FETCH_SUBMITTALS_PENDING_REVIEW_COUNT = 'FETCH_SUBMITTALS_PENDING_REVIEW_COUNT';
export const GET_RESPONSE_VIDEO_FOR_PENDING_SUBMITTAL = 'GET_RESPONSE_VIDEO_FOR_PENDING_SUBMITTAL';
export const GET_RESPONSE_VIDEO_FOR_COMPLETED_SUBMITTAL = 'GET_RESPONSE_VIDEO_FOR_COMPLETED_SUBMITTAL';
export const SUBMIT_SWING_REVIEW = 'SUBMIT_SWING_REVIEW';
export const UPLOAD_SUBMITTAL_REPLY_VIDEO = 'UPLOAD_SUBMITTAL_REPLY_VIDEO';
export const UPLOAD_SUBMITTAL_REPLY_VIDEO_PROGRESS = 'UPLOAD_SUBMITTAL_REPLY_VIDEO_PROGRESS';

export function fetchSubmittalsPendingReview() {
  return {
    type: FETCH_SUBMITTALS_PENDING_REVIEW,
    promise: client.get('swing-submittals/pending-review'),
  };
}

export function fetchSubmittalsHistory(query) {
  return {
    type: FETCH_SUBMITTALS_HISTORY,
    promise: client.get('swing-submittals/history', query),
  };
}

export function fetchSubmittalsPendingReviewCount() {
  return {
    type: FETCH_SUBMITTALS_PENDING_REVIEW_COUNT,
    promise: client.get('swing-submittals/pending-review-count'),
  };
}

export function updateUploading(uploading) {
  return {
    type: UPLOAD_SUBMITTAL_REPLY_VIDEO,
    uploading,
  };
}

export function updateUploadProgress(loaded, total) {
  return {
    type: UPLOAD_SUBMITTAL_REPLY_VIDEO_PROGRESS,
    loaded,
    total,
  };
}

export function addResponseVideoToSubmittal(submittalId, key) {
  return {
    type: ADD_RESPONSE_VIDEO_TO_SUBMITTAL,
    promise: client.post(`swing-submittals/${submittalId}/response-video`, { key }),
  };
}

export function getResponseVideoForPendingSubmittal(submittalId) {
  return {
    submittalId,
    type: GET_RESPONSE_VIDEO_FOR_PENDING_SUBMITTAL,
    promise: client.get(`swing-submittals/${submittalId}/response-video`, null, {
      credentials: 'include', // Required for browser to respect Set-Cookie headers
    }),
  };
}

export function getResponseVideoForCompletedSubmittal(submittalId) {
  return {
    submittalId,
    type: GET_RESPONSE_VIDEO_FOR_COMPLETED_SUBMITTAL,
    promise: client.get(`swing-submittals/${submittalId}/response-video`, null, {
      credentials: 'include', // Required for browser to respect Set-Cookie headers
    }),
  };
}

export function submitSwingReview(submittalId) {
  return {
    submittalId,
    type: SUBMIT_SWING_REVIEW,
    promise: client.patch(`swing-submittals/${submittalId}/respond`),
  };
}

export function uploadVideo(submittalId, file) {
  return dispatch => {
    dispatch(updateUploading(true));
    return uploadVideoToS3(dispatch, file, updateUploadProgress)
      .then(data => dispatch(addResponseVideoToSubmittal(submittalId, data.Key)))
      .then(() => dispatch(getResponseVideoForPendingSubmittal(submittalId)))
      .then(() => {
        dispatch(updateUploading(false));
        dispatch(updateUploadProgress(0, 100));
      });
  };
}



// WEBPACK FOOTER //
// ./src/swing-submittals/actions.js